import {useNewProduct} from "../../../store/contexts/NewProductContext";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import {useState} from "react";

const ThumbnailCard = () => {

  const {product, dispatch} = useNewProduct();

  const [thumbnailUrl, setThumbnailUrl] = useState(null);
  const [changed, setChanged] = useState(false)

  const handleChange = (e) => {
    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {...product, thumbnail: e.target.files[0]}
    });

    setThumbnailUrl(e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : null);
    setChanged(true)
  }

  return (
        <div className="card card-flush py-4">
            <div className="card-header">
                <div className="card-title">
                    <h2>Thumbnail</h2>
                </div>
            </div>
            <div className="card-body text-center pt-0">
                <div className="image-input image-input-empty image-input-outline mb-3"
                     data-kt-image-input="true"
                     style={{backgroundImage: `url(${(changed ? thumbnailUrl : product.thumbnail) || "assets/media/svg/files/blank-image.svg"})`}}>
                    <div className="image-input-wrapper w-150px h-150px"></div>

                    <label
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="change" data-bs-toggle="tooltip"
                        title="Change avatar">
                        <i className="bi bi-pencil-fill fs-7"></i>

                      <input
                        type="file"
                        name="thumbnail"
                        accept=".png, .jpg, .jpeg, .webp"
                        onChange={e => handleChange(e)}
                      />
                    </label>

                    <span
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="cancel" data-bs-toggle="tooltip"
                        title="Cancel avatar">
                                        <i className="bi bi-x fs-2"></i>
                                    </span>

                    <span
                        className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="remove" data-bs-toggle="tooltip"
                        title="Remove avatar">
                                        <i className="bi bi-x fs-2"></i>
                                    </span>
                </div>

                <div className="text-muted fs-7">Set the product thumbnail image. Only *.png, *.jpg and
                    *.jpeg image files are accepted
                </div>
            </div>
        </div>
    )
}

export default ThumbnailCard;